import React, { useState } from 'react'
 
import AssignRegionForm from './AssignRegionForm';
import AssignRegionList from './AssignRegionList';

const AssignRegion= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <AssignRegionForm addForm={setFromIsShown} update={upData} />
        ) : (
          <AssignRegionList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default AssignRegion